export const areaInfo = {
  key: "areaInfo",
  config: {
    name: "批而未供土地",
    title: "批而未供",

    panels: (opts = {} as any) => {
      const { type, data } = opts;
      return [
        {
          title: () => {
            return "";
          },
          panels: [
            {
              title: () => {
                return data.title;
              },
              items: [
                {
                  span: "24",
                  label: "组长",
                  labelStyle: { marginRight: "10px" },
                  value: () => {
                    return data.zuzhang || "-";
                  },
                },
                {
                  span: "24",
                  label: "牵头人",
                  labelStyle: { marginRight: "10px" },
                  value: () => {
                    return data.qiantouren || "-";
                  },
                },
                {
                  span: "24",
                  label: "责任部门",
                  labelStyle: { marginRight: "10px" },
                  value: () => {
                    return data.zerenbumen || "-";
                  },
                },
                {
                  span: "24",
                  label: "负责范围",
                  labelStyle: { marginRight: "10px" },
                  value: () => {
                    return data.fuzefanwei || "-";
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
} as any;
